import type { IconProps } from './base';
import { BaseIcon } from './base';

export function IconBrandAnthropic(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <g transform="scale(0.6)">
        <path
          d="M27.9653 8H22.4599L32.4946 33H38L27.9653 8ZM12.0347 8L2 33H7.62256L9.69197 27.7692H20.1952L22.2256 33H27.8482L17.8134 8H12.0347ZM11.4881 23.1154L14.9241 14.3462L18.3601 23.1154H11.4881Z"
          fill="currentColor"
        />
      </g>
    </BaseIcon>
  );
}
